<form
  [formGroup]="form"
  (ngSubmit)="onFormSubmit()"
  #formRef="ngForm"
  [patchForm]="formValues$ | async"
  [canEdit]="[accessRights.ConfigurationOptions_write]"
  [canEdit]="[accessRights.Settings_write]"
>
  <!-- Card -->
  <section class="card mb-3">
    <div class="card-header card-collapse">
      <!-- Header -->
      <h2 class="accordion-header">
        <button
          class="accordion-button"
          [attr.aria-expanded]="isCollapsed ? 'false' : 'true'"
          (click)="isCollapsed = !isCollapsed"
          type="button"
          aria-controls="contactPage"
        >
          <span class="fs-3">{{
            'configurationOptionModule.contactPage' | translate
          }}</span>

          <i
            class="fa fa-fw"
            [ngClass]="isCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'"
            attr.aria-label="{{ 'wcag.toggleSection' | translate }}"
            role="img"
          ></i>
        </button>
      </h2>

      <!-- End Header -->
    </div>

    <div *ngIf="!isCollapsed" id="contactPage">
      <div class="card-body">
        <div class="">
          <label class="form-label">{{
            'configurationOptionModule.contactPageHTML' | translate
          }}</label>
          <summernote-languages
            [formData]="form"
            [summerNoteFieldEn]="'en_contact_me_page_html'"
            [summerNoteFieldNl]="'nl_contact_me_page_html'"
            [summerNoteFieldDe]="'de_contact_me_page_html'"
            [summerNoteFieldFr]="'fr_contact_me_page_html'"
          ></summernote-languages>
        </div>

        <div class="d-flex justify-content-end pt-3">
          <button
            class="btn btn-primary"
            type="submit"
            [canSee]="[accessRights.Settings_write]"
            [canSee]="[accessRights.ConfigurationOptions_write]"
          >
            {{ 'general.save' | translate }}
          </button>
        </div>
      </div>
    </div>
  </section>
  <!-- End Card -->
</form>
